var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"width-100"},[_c('div',{staticClass:"back",on:{"click":_vm.toTop}},[_c('van-icon',{attrs:{"name":"arrow-up","size":"20px","color":"#ffffff"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }